import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaFilePdf, FaArrowLeft, FaArrowRight, FaTimes } from "react-icons/fa";
import "./tenderslist.css";

const newsData = [
    {
        id: 1,
        title: "Tenders",
        description: "ശ്രീ തിരുനെല്ലി മഹാവിഷ്‌ണു ക്ഷേത്രചുറ്റുമതിലിന് പുറത്ത് ഊട്ടുപുരയുടെയും, സംരക്ഷണ ഭിത്തിയുടെയും നിർമ്മാണ പ്രവർത്തി ഏറ്റെടുത്ത് നടത്തുന്നതിന് ",
        images: ["/images/slider-1.jpg", "/images/slider-2.jpg"],
        pdf: "./images/qtn.pdf",
    },
    {
        id: 2,
        title: "Tenders",
        description: "ശ്രീ തിരുനെല്ലി മഹാവിഷ്‌ ക്ഷേത്രം പഞ്ചതീർത്ഥം വിശ്രമ മന്ദിരത്തിൻ്റെ പുനരുദ്ധാരണ്യ പ്രവർത്തിക്ക് ശേഷം അഴിച്ച് മാറ്റിയ സാധനങ്ങളുടെ ലേലം",
        images: ["/images/slider-1.jpg"],
        pdf: "./images/qtn_1.pdf",
    },
];

const TendersList = () => {
    const [lightbox, setLightbox] = useState(false);
    const [activeImages, setActiveImages] = useState([]);
    const [imgIndex, setImgIndex] = useState(0);

    const openLightbox = (images, index = 0) => {
        setActiveImages(images);
        setImgIndex(index);
        setLightbox(true);
    };

    const nextImage = () => {
        setImgIndex((prev) => (prev + 1) % activeImages.length);
    };

    const prevImage = () => {
        setImgIndex((prev) =>
            prev === 0 ? activeImages.length - 1 : prev - 1
        );
    };

    return (
        <div className="row">
            <div className="list-wrapper col-md-12" >
            {/* <h2 style={{ marginTop: '50px' }}>Tenders</h2>
            <hr /> */}
            {newsData.map((item) => (
                <motion.div
                    key={item.id}
                    className="list-card"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }} style={{border:'1px solid silver',padding:'15px'}}
                >
                    {/* LEFT IMAGE */}
                    {/* <div className="thumb">
                        <img
                            src={item.images[0]}
                            alt={item.title}
                            onClick={() => openLightbox(item.images)}
                        />
                    </div> */}

                    {/* RIGHT CONTENT */}
                    <div className="content" style={{padding:'15px'}}>
                        <div className="content-left">
                            {/* <h3 style={{fontFamily:'anek malayalam',borderBottom:'1px solid maroon'}}>{item.title}</h3> */}
                            <p style={{fontFamily:'anek malayalam',lineHeight:'15pt'}}>{item.description}</p>
                        </div>

                        <div className="content-right">
                            {item.pdf && (
                                <motion.a
                                    href={item.pdf}
                                    target="_blank"
                                    className="pdf-btn"
                                    whileHover={{ scale: 1.1 }}
                                >
                                    <FaFilePdf /> View More  </motion.a>
                            )}
                        </div>
                    </div>
                </motion.div>
            ))}

            {/* LIGHTBOX */}
            <AnimatePresence>
                {lightbox && (
                    <motion.div
                        className="lightbox"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <FaTimes
                            className="close-btn"
                            onClick={() => setLightbox(false)}
                        />

                        <img
                            src={activeImages[imgIndex]}
                            alt="preview"
                            className="lightbox-img"
                        />

                        {activeImages.length > 1 && (
                            <>
                                <button
                                    className="lightbox-btn left"
                                    onClick={prevImage}
                                >
                                    <FaArrowLeft />
                                </button>
                                <button
                                    className="lightbox-btn right"
                                    onClick={nextImage}
                                >
                                    <FaArrowRight />
                                </button>
                            </>
                        )}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
        </div>
        
    );
};

export default TendersList;